import React from 'react'
import { useTranslation } from 'react-i18next'
import colozooLogo from '../../assets/colozoo_logo.svg'

// Shared header of the redesigned pages: logo, optional in-page nav, language select, one red CTA.

export const brandLanguages = [
  { lng: 'en-GB', label: 'EN' },
  { lng: 'en-US', label: 'EN-US' },
  { lng: 'de', label: 'DE' },
  { lng: 'fr', label: 'FR' },
  { lng: 'it', label: 'IT' },
  { lng: 'es', label: 'ES' },
]

const GlobeIcon = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15 15 0 0 1 0 20a15 15 0 0 1 0-20" /></svg>
)

interface BrandHeaderProps {
  logoHref: string
  nav?: { href: string, label: string }[]
  cta: { href: string, label: string, external?: boolean }
  onLanguageChange?: (lng: string) => void
}

const BrandHeader = ({ logoHref, nav = [], cta, onLanguageChange }: BrandHeaderProps) => {
  const { i18n } = useTranslation()
  const current = brandLanguages.find((l) => l.lng === i18n.language)
    || brandLanguages.find((l) => l.lng === i18n.language.split('-')[0])
    || brandLanguages[0]

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
    onLanguageChange?.(lng)
  }

  return (
    <header className="czb-header">
      <div className="czb-wrap czb-header-row">
        <a href={logoHref} className="czb-logo-link"><img src={colozooLogo} alt="Colozoo" className="czb-logo" /></a>
        {nav.length > 0 && (
          <nav aria-label="Main" className="czb-nav">
            {nav.map((n) => <a key={n.href} href={n.href}>{n.label}</a>)}
          </nav>
        )}
        <div className="czb-header-actions">
          <label className="czb-lang">
            <GlobeIcon />
            <span className="czb-sr">Language</span>
            <select value={current.lng} onChange={(e) => changeLanguage(e.target.value)}>
              {brandLanguages.map((l) => <option key={l.lng} value={l.lng}>{l.label}</option>)}
            </select>
          </label>
          <a
            href={cta.href}
            className="czb-btn czb-btn-red czb-btn-sm"
            {...(cta.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            {cta.label}
          </a>
        </div>
      </div>
    </header>
  )
}

export default BrandHeader
